
// native
import { Injectable } from '@angular/core';
import { merge, Observable, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

// service
import { ApiService } from './api.service';
import { UtilityService } from './utility.service';
import { GlobalsService } from './globals.service';

// model
import { IList, IListDataResponse, ListNode } from '../../models';

export interface IDataListQueryParams {
  collection_id: string;
  created_since?: string;
  modified_since?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ListService {
  currentList$: Subject<IList> = new Subject<IList>();
  reload$ = new Subject<void>();

  constructor(
    private apiService: ApiService,
    private utilityService: UtilityService,
    private globalsService: GlobalsService
  ) { }

  private mapListData(lists: any): IList[] {
    return lists.map((list: IList) => {
      return {
        id: list.id,
        collection_id: list.collection_id,
        parent_id: list.parent_id || null,
        name: list.name || '',
        deleted: list.deleted || false,
        item_ids: list.item_ids || []
      };
    });
  }

  getLists(params?: IDataListQueryParams): Observable<IList[]> {
    const endpointUrl = `${this.globalsService.appConfig.environment.baseUrls.sync}/collections/${params.collection_id}/lists`;
    return this.apiService.get(endpointUrl).pipe(
      map((body: IListDataResponse) => this.mapListData(body.lists || []))
    );
  }

  getListsTreeByCollectionId$(collectionId: string): Observable<ListNode[]> {
    const get$ = this.getLists({ collection_id: collectionId });
    const reload$ = this.reload$.pipe(switchMap(() => get$));

    return merge(get$, reload$).pipe(
      map((lists: IList[]) => lists.filter(l => l.collection_id === collectionId)),
      map(lists => this.utilityService.unflattenLists(lists)),
      map(root => root.children)
    );
  }

  reload() {
    this.reload$.next();
  }
}